import { AltTextFixerProvider, AltTextImageGrid, RuleListStatus } from '@wix/rules-panel-ui';
import { useAtomValue } from 'jotai';
import React from 'react';
import { verticalsDrillInPageIdAtom } from '../../../atoms/session-atoms';
import { useA11yAltTextContext } from '../../../hooks/use-a11y-alt-text-context';
import { useCollapseClose } from '../../wizard-content/content-results/card-groups/lists/context/collapse-actions-context';
import { adaptWizardAltImagePropsToShared } from './utils/adapt-wizard-props';

/**
 * Props for the A11yAltTextImageGridWrapper component
 */

/**
 * A11y-specific wrapper for the shared AltTextImageGrid component from rules-panel-ui
 *
 * This wrapper integrates the shared alt-text fixer with a11y-wizard's infrastructure:
 * - Builds the context using a11y-wizard's BI logger, translations, and design props
 * - Converts wizard-specific image props to the shared format
 * - Properly handles collapse using a11y-wizard's CollapseActionsContext
 */
export const A11yAltTextImageGridWrapper = _ref => {
  let {
    altImageProps,
    uiStatus,
    pageId,
    itemType,
    collapseRule,
    setAltTextScreenProps
  } = _ref;
  const contextValue = useA11yAltTextContext();
  const sharedAltImageProps = adaptWizardAltImagePropsToShared(altImageProps);
  const handleCancel = useCollapseClose(collapseRule);
  const verticalsDrillInPageId = useAtomValue(verticalsDrillInPageIdAtom);
  return /*#__PURE__*/React.createElement(AltTextFixerProvider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(AltTextImageGrid, {
    images: sharedAltImageProps,
    openDrillInScreen: () => {
      setAltTextScreenProps({
        itemType,
        pageId,
        returnTo: verticalsDrillInPageId ? 'verticals' : 'main'
      });
    },
    taskStatus: uiStatus !== RuleListStatus.failed,
    onClickCancel: handleCancel
  }));
};
//# sourceMappingURL=a11y-alt-text-image-grid-wrapper.js.map